import { render, staticRenderFns } from "./DeaceasedDetailsModal.vue?vue&type=template&id=c4a2b618&"
import script from "./DeaceasedDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DeaceasedDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports